<div class="gcontainer bwhite">
  <div class="row">
    <div class="col-md-11">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            (keypress)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active" aria-current="page">Access Management</li>
        </ol>
      </nav>
    </div>

    <h1>Access Management</h1>

    <!-- Tabs -->
    <mat-tab-group>
      <mat-tab label="Customers">
        <app-customer-management></app-customer-management>
      </mat-tab>
      <mat-tab label="Geotherm Users">
        <app-user-management></app-user-management>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
